export function logAndReturnErrorMsg(error, callerMsg) {
	let errorMsg = error.message;
	if (error.response) {
		if (error.response.data.error){
			errorMsg = error.response.data.error;
		}
	}
	console.log(callerMsg, error.response);
	return `${callerMsg}: ${errorMsg}`;
}
